// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__I2WoI","head":"ProcedureTableInfo_head__3aH3R"};